












import { createComponent } from "@vue/composition-api";
import { useDictionary } from "../views/compositions/useDictionary";

export default createComponent({
  props: {
    percentage: {
      type: Number,
      required: true
    }
  },
  setup() {
    const dictionary = useDictionary();
    return {
      ...dictionary
    };
  }
});
